<template>
  <div class="container page recharge-page">
    <van-nav-bar :title="$t('frontend.finance.recharge')" class="nav-bar">
      <template #left><van-icon name="arrow-left" color="#fff" @click="back" /></template>
    </van-nav-bar>
    <main class="recharge-page__main">
      <section class="recharge-page__balance">
        <p>{{ $t('frontend.finance.account', { name: username }) }}</p>
        <strong>{{ balance }} <small>{{ $t('frontend.account.currency') }}</small></strong>
      </section>
      <section class="recharge-page__guide">
        <van-icon name="service-o" />
        <p>{{ $t('frontend.finance.recharge_guide') }}</p>
        <van-button block round type="info" @click="contactAgent">{{ $t('frontend.finance.contact_agent') }}</van-button>
      </section>
    </main>
  </div>
</template>

<script>
import { assertResponse, displayNumber } from "../../common/reference";

export default {
  data: () => ({ userInfo: {} }),
  computed: {
    username() { return this.userInfo.username || "-"; },
    balance() { return displayNumber(this.userInfo.money); }
  },
  methods: {
    back() { window.history.back(); },
    contactAgent() { this.$router.push("/Home"); },
    async load() {
      try {
        this.userInfo = assertResponse(await this.$http({ method: "get", url: "user_info" }));
      } catch (error) {
        this.$toast(error.message || this.$t('frontend.account.load_failed'));
      }
    }
  },
  created() {
    if (!localStorage.getItem("token")) this.$router.push("/Login");
    else this.load();
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";
.recharge-page { background: #f2f2f5; }
.recharge-page__main { padding: 30px 24px; }
.recharge-page__balance { padding: 34px 28px; color: #fff; background: linear-gradient(270deg, #e6c3a1, #7e5678); border-radius: 12px; }
.recharge-page__balance p { margin: 0 0 18px; font-size: 30.24px; }
.recharge-page__balance strong { font-size: 56.16px; font-weight: 700; }
.recharge-page__balance small { font-size: 28.08px; font-weight: 700; }
.recharge-page__guide { margin-top: 24px; padding: 56px 32px 36px; background: #fff; text-align: center; border-radius: 12px; }
.recharge-page__guide .van-icon { color: #8a6381; font-size: 76px; }
.recharge-page__guide p { margin: 30px 0 42px; color: #666; font-size: 31.32px; line-height: 1.8; text-align: left; }
.recharge-page__guide .van-button { height: 82px; font-size: 33.48px; border: 0; background: linear-gradient(90deg, #e6c3a1, #7e5678); }
</style>
